<template>
  <Welcome/>
  <Marquee />
  <WhoWeAre />
  <WhatWeDo />
  <WhyChoose />
  <Partners />
  <ContactUs />
  <Footer />
</template>

<script>
import Welcome from "@/components/sections/Welcome.vue";
import Marquee from "@/components/additional/Marquee.vue";
import WhoWeAre from "@/components/sections/WhoWeAre.vue";
import WhatWeDo from "@/components/sections/WhatWeDo.vue";
import WhyChoose from "@/components/sections/WhyChoose.vue";
import Partners from "@/components/sections/Partners.vue";
import Footer from "@/components/base/Footer.vue";
import ContactUs from "@/components/sections/ContactUs.vue";

export default {
  name: 'App',
  components: {
    ContactUs,
    Footer,
    Partners,
    WhyChoose,
    WhatWeDo,
    WhoWeAre,
    Marquee,
    Welcome,
  }
}
</script>

<style>
#app {
  background: #070707;
  overflow: hidden;
}
</style>
